export const ACTION = '/Account/isUserExist';
